// public/v3/src/lib/feature-catalog.js — client mirror of server/lib/featureCatalog.js.
// A drift-guard test (tests/unit/v3/feature-catalog-mirror.test.js) keeps the key
// list identical to the server. Labels are display strings for the role editor.
export const ALL_FEATURES = [
  'timelogs', 'studio', 'apcm', 'onboard', 'faxinbox', 'orderchat', 'intake', 'scheduling', 'kiosk', 'usermgmt', 'settings', 'noteexpander', 'voicelog',
];
export const ADMIN_ONLY_FEATURES = ['kiosk', 'usermgmt'];
export const FEATURE_LABELS = {
  timelogs: 'Time Logs',
  studio: 'Review & Push',
  apcm: 'APCM Fallback',
  onboard: 'Onboard',
  faxinbox: 'Fax Inbox',
  orderchat: 'Order Chat',
  intake: 'Intake Review',
  scheduling: 'Scheduling',
  kiosk: 'Kiosk',
  usermgmt: 'User Management',
  settings: 'Settings',
  noteexpander: 'Note Expander',
  voicelog: 'Voice Log',
};
// Features a base tier may hold (admin-only features excluded for non-admins).
export function featuresAllowedForTier(tier) {
  if (tier === 'admin') return [...ALL_FEATURES];
  if (tier === 'provider' || tier === 'staff') return ALL_FEATURES.filter(f => !ADMIN_ONLY_FEATURES.includes(f));
  return [];
}
